const STATUS_LIST = ["hybrid_broadcast", "listen", "broadcast", "private", "eod"];
const STATUS_MAP = {
    hybrid_broadcast: "shared",
    listen: "shared",
    private: "local",
    broadcast: "broadcast",
    eod: "eod",
};
export const Status = {
    isShared: (status) => status === "hybrid_broadcast" || status === "listen" || status === "broadcast",
    isPrivate: (status) => status === "private",
    isBroadcast: (status) => status === "broadcast",
    isHybrid: (status) => status === "hybrid_broadcast",
    isEod: (status) => status === "eod",
    isGlobal: (status) => typeof status !== "undefined" && !STATUS_LIST.includes(status),
    instrumentType: (status = "listen") => STATUS_LIST.includes(status) ? STATUS_MAP[status] : "global",
    storageType: (status = "listen") => {
        if (Status.isPrivate(status))
            return "local";
        if (Status.isGlobal(status))
            return "global";
        return "shared";
    },
};
//# sourceMappingURL=status.js.map